import styled, { css } from 'styled-components/macro';
import { ReactComponent as Chevron } from '../../assets/icons/chevron-down.svg';
import { ReactComponent as X } from '../../assets/icons/x.svg';
import {
  spacingDefault,
  maxWidthDefault,
  spacingDesktop
} from '../../styles/utils';
import Icon from '../../components/Icon';
import { TransactionFilterDiv } from '../TableFilterStyles';

export const FiltersDiv = styled.div`
  flex-grow: 1;
  max-width: 100%;
  @media screen and (max-width: 767px) {
    margin: 0 2rem;
  }
  ${props =>
    props.titleRow &&
    css`
      @media screen and (min-width: 1024px) {
        max-width: 650px;
        margin-left: auto;
      }
    `}
  @media screen and (min-width: 1440px) {
    max-width: ${maxWidthDefault - 160}px;
  }
`;

export const FiltersSectionDiv = styled.div`
  display: flex;
  height: 4rem;
  align-items: flex-start;
  border: ${props => props.theme.defaultBorder};
  background-color: white;
  @media screen and (max-width: 767px) {
    margin-top: 1rem;
  }
  ${props =>
    props.payoutsMobileCustom &&
    css`
      border: 1px solid ${props => props.theme.brand};
      display: flex;
      justify-content: space-between;
      flex-grow: 1;
      padding: 0px 1.5rem;
      align-items: center;
      > p {
        color: ${props => props.theme.brand};
        margin-right: 1rem;
      }
    `}
`;

export const FilterToggleP = styled.p`
  font-weight: 500;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (min-width: 768px) {
    margin-top: 2rem;
    flex-direction: row;
    justify-content: center;
    /* ${props =>
      props.filter === 'Transaction' &&
      css`
        margin-top: 2rem;
      `} */
  }
  @media screen and (min-width: 1024px) {
    width: 100%;
    ${props =>
      props.filter === 'Settlement' &&
      css`
        justify-content: flex-end;
      `}
  }
`;

export const FilterSubContainer = styled.div`
  @media screen and (min-width: 768px) {
    width: calc(100% - ${spacingDefault});
    /* width: 90%; */
    display: flex;
  }
  @media screen and (min-width: 1440px) {
    width: calc(100% - ${spacingDesktop});
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media screen and (max-width: 767px) {
    margin-top: 17px;
    &.secondRow {
      margin-top: 10px;
    }
  }
  @media screen and (min-width: 768px) {
    /* margin-top: 10px; */
    /* width: 50%; */
    ${props =>
      props.searchBarToggled
        ? css`
            width: 35%;
            &.secondRow {
              width: 65%;
            }
          `
        : 'width: 100%'}
  }
`;

export const ChevronSvg = styled(Chevron)`
  ${props => props.open && 'transform: rotate(180deg);'};
  width: 20px;
  height: 20px;
  margin-left: 6px;
  z-index: 0;
`;

export const XSvg = styled(X)`
  width: 6px;
  fill: ${props => props.theme.dustyGray};
`;

export const FilterSubWrapper = styled.div`
  display: flex;
  /* width: 90%; */
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 40px);
  height: 36px;
  display: flex;
  > h5 {
    margin-top: -3px;
  }
  @media screen and (min-width: 768px) {
    width: 100%;
  }
  padding-bottom: 10px;
`;

export const FilterButtonToggleWrapper = styled.div`
  cursor: pointer;
  align-items: center;
  display: flex;
  ${props =>
    !props.open &&
    css`
      margin-top: -3rem;
    `}
`;

export const CsvDiv = styled.div`
  display: flex;
  align-items: center;
`;

// export const CsvP = styled.p`
//   color: ${props => props.theme.brand};
//   font-size: 1.3rem;
// `;
export const ArrowDownIcon = styled(Icon)`
  fill: ${props => props.theme.brand};
  width: 2rem;
  height: 1.2rem;
`;

export const FilterHeaderDownloadDiv = styled.div`
  display: flex;
  justify-content: space-between;
  ${TransactionFilterDiv} {
    flex-grow: unset;
  }
`;
